import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { MockProfileService, Follower } from '../../services-mock/mock-profile.service';

@Component({
  selector: 'app-following',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, AvatarModule],
  template: `
    <div class="following-container">
      <div class="following-header">
        <button
          pButton
          type="button"
          icon="pi pi-arrow-left"
          label="Back"
          (click)="goBack()"
          class="back-button"
        ></button>
        <h2 class="following-title">Following</h2>
      </div>

      <div class="following-list" *ngIf="following.length > 0">
        <div *ngFor="let person of following" class="following-item">
          <div class="following-info">
            <p-avatar
              [label]="person.initials"
              shape="circle"
              size="normal"
            ></p-avatar>
            <div class="following-details">
              <div class="following-name">{{ person.name }}</div>
              <div class="following-title">{{ person.title }}</div>
              <div class="following-company">{{ person.company }}</div>
            </div>
          </div>
          <button
            pButton
            type="button"
            label="Unfollow"
            class="unfollow-button"
            (click)="unfollow(person)"
          ></button>
        </div>
      </div>

      <div class="no-following" *ngIf="following.length === 0 && !loading">
        <div class="no-following-content">
          <i class="pi pi-user-plus no-following-icon"></i>
          <h3>Not following anyone yet</h3>
          <p>Start following people to see their updates in your feed!</p>
        </div>
      </div>

      <div class="loading" *ngIf="loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading...</span>
      </div>
    </div>
  `,
  styles: [
    `
      .following-container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 1.5rem;
        background-color: #f5f5f5;
        min-height: calc(100vh - 60px);
      }

      .following-header {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1.5rem;
      }

      .back-button {
        background: transparent;
        color: #666666;
        border: 1px solid #e5e5e5;
      }

      .following-title {
        font-size: 1.75rem;
        font-weight: 600;
        color: #000000;
        margin: 0;
      }

      .following-list {
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        overflow: hidden;
      }

      .following-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.5rem;
        border-bottom: 1px solid #e5e5e5;
      }

      .following-item:last-child {
        border-bottom: none;
      }

      .following-info {
        display: flex;
        align-items: center;
        gap: 1rem;
        flex: 1;
      }

      .following-details {
        display: flex;
        flex-direction: column;
      }

      .following-name {
        font-weight: 600;
        font-size: 1rem;
        color: #000000;
        margin-bottom: 0.25rem;
      }

      .following-title {
        font-size: 0.9rem;
        color: #666666;
        margin-bottom: 0.25rem;
      }

      .following-company {
        font-size: 0.85rem;
        color: #999999;
      }

      .unfollow-button {
        background: transparent;
        color: #666666;
        border: 1px solid #e5e5e5;
      }

      .unfollow-button:hover {
        background: #f5f5f5;
      }

      .no-following {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;
        padding: 3rem;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      }

      .no-following-content {
        text-align: center;
        max-width: 400px;
      }

      .no-following-icon {
        font-size: 4rem;
        color: #cccccc;
        margin-bottom: 1rem;
      }

      .no-following-content h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #000000;
        margin: 0 0 0.5rem 0;
      }

      .no-following-content p {
        font-size: 1rem;
        color: #666666;
        margin: 0;
      }

      .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        padding: 3rem;
        background-color: #ffffff;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        color: #666666;
      }

      .loading i {
        font-size: 2rem;
      }
    `,
  ],
})
export class FollowingComponent implements OnInit {
  following: Follower[] = [];
  loading = true;

  constructor(
    private profileService: MockProfileService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadFollowing();
  }

  loadFollowing() {
    this.loading = true;
    this.profileService.getFollowing().subscribe((following) => {
      this.following = following;
      this.loading = false;
    });
  }

  unfollow(person: Follower) {
    // In a real app, this would call a service to unfollow
    const index = this.following.findIndex((p) => p.id === person.id);
    if (index > -1) {
      this.following.splice(index, 1);
    }
  }

  goBack() {
    this.router.navigate(['/profile']);
  }
}

